import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { isArray } from 'lodash';
import LeftContainer from './LeftContainer';
import RightContainer from './RightContainer';
import { getVersionNumber } from '../../util';
import { LoginLayout } from './styled';

const Login = ({ apiActions, authentication, location }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [serverError, setServerError] = useState(null);

  const { postLoginRequest } = apiActions;

  const onSubmit = (value) => {
    setIsSubmitted(true);
    setServerError(null);
    const { username, password, remember } = value;

    localStorage.setItem('version-number', getVersionNumber());
    localStorage.setItem('userName', username);
    postLoginRequest({ username, password });
  };

  useEffect(() => {
    if (authentication) {
      const { error, data } = authentication;
      if (error) {
        const { message } = error;
        if (isSubmitted) {
          setServerError(message || error);
          setIsSubmitted(false);
        }
      }

      if (data && isArray(data) && localStorage.getItem('id_token')) {
        const redirectUrl = location?.state?.from?.pathname;

        if (location?.state !== undefined) window.location = redirectUrl;
        else window.location = '/app';
      }
    }
  }, [authentication]);

  return (
    <LoginLayout>
      <Row>
        <Col span={12} style={{ height: '100vh' }}>
          <LeftContainer
            onSubmit={onSubmit}
            isSubmitted={isSubmitted}
            error={serverError}
          />
        </Col>
        <Col span={12} style={{ height: '100vh' }}>
          <RightContainer />
        </Col>
      </Row>
    </LoginLayout>
  );
};

Login.propTypes = {
  apiActions: PropTypes.object.isRequired,
  authentication: PropTypes.object
};

export default Login;
